import { PatientDetails } from "@/models";

export function getPatientFullName(patient: PatientDetails) {
  if (patient && patient.phi) {
    const first = patient.phi.firstName || "";
    const middle = patient.phi.middleName || "";
    const last = patient.phi.lastName || "";

    const fullName = `${first} ${middle} ${last}`.trim();
    // Convert the name to title case. Split after joining the first and last because some people have multiple last names
    return fullName
      .split(" ")
      .map(n => n.trim())
      .filter(n => n) // Only capture non-empty fields (e.g. skip empty middle name)
      .map(n => (n ? n[0].toLocaleUpperCase() + n.substring(1).toLocaleLowerCase() : ""))
      .join(" ");
  }
  return "";
}
